/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { connect } from 'react-redux';
import { object } from 'prop-types';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';

import mbpLogger from 'mbp-logger';

import WineDisclaimer from './WineDisclaimer';
import { GRAPHQL_ENV } from '../../../../../gql';
import { getBrand } from '../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';

const GraphqlWineContainer = ({
    brand,
}) => {
    const WINE_DISCLAIMER_QUERY = gql`
    query WineDisclaimer {
        findContent(brand: "${brand['domain-name']}", environment: "${GRAPHQL_ENV}", contentType: "marketing_spots")
        {
          content
        }
    }
    `;
    console.log('GRAPHQL_ENV', GRAPHQL_ENV);
    return (
        <Query query={WINE_DISCLAIMER_QUERY}>
            {({ loading, error, data }) => {
                if (loading) {
                    return null; // skeleton component
                }

                if (error) {
                    mbpLogger.logError({
                        query: WINE_DISCLAIMER_QUERY,
                        component: 'GraphqlWineContainer.js',
                        message: 'Error loading data from Graphql',
                        env: GRAPHQL_ENV,
                        error,
                    });
                    return null;
                }

                if (!data) {
                    mbpLogger.logWarning({
                        query: WINE_DISCLAIMER_QUERY,
                        component: 'GraphqlWineContainer.js',
                        message: 'No data returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }

                const { content } = data.findContent;
                if (!content) {
                    mbpLogger.logWarning({
                        query: WINE_DISCLAIMER_QUERY,
                        component: 'GraphqlWineContainer.js',
                        message: 'No content returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }

                return (
                    <WineDisclaimer brand={brand} data={data} />
                );
            }}
        </Query>
    );
};

const mapStateToProps = (state) => ({
    brand: getBrand(state),
});

GraphqlWineContainer.propTypes = {
    brand: object.isRequired,
};

export default connect(
    mapStateToProps,
    null,
)(GraphqlWineContainer);
